import React, { useCallback, useEffect, useState } from 'react'
import { DI, DIProps } from '../../../../Core';
import { Card, Autocomplete, Button, Collapsible, InlineStack, Icon, SkeletonBodyText, Tag, Text, BlockStack, Grid, Box, Bleed, Divider } from '@shopify/polaris';
import { ChevronDownMinor, ChevronUpMinor, CircleMinusMajor, CirclePlusMajor, SearchMinor } from '@shopify/polaris-icons';
import { syncConnectorInfo, syncNecessaryInfo, } from '../../../../Actions/NecessaryFun';
import reactStringReplace from 'react-string-replace';
import logo from '../../../../Asests/Images/NoResultsFound.png';
import { Tabs, TabsProps } from 'antd';
import '../css/newStyles.css';
import { useTranslation } from 'react-i18next';

interface props extends DIProps { }

const NewFaq = (props: props) => {
  const fromPricingPlan = props.di.globalState.get('fromPricingPlan') || false;
  const [selectedOptions, setSelectedOptions] = useState<any>([]);
  const [inputValue, setInputValue] = useState('');
  const [options, setOptions] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [arr, setallFaq] = useState<any>({});
  const [showMoreLessInfo, setshowMoreLessInfo] = useState<any>({})
  const [resultQuery, setresultQuery] = useState<any>("")
  const [showButtonLoading, setshowButtonLoading] = useState<any>({})
  const [loadSkeleton, setloadSkeleton] = useState(true)
  const [lastId, setLastId] = useState<any>();
  const [groupName, setGroupName] = useState<any>(null);
  const [keyword, setKeyWord] = useState<any>('');
  const [loadSectionSkeleton, setLoadSectionSkeleton] = useState(false);
  const [noResult, setNoResult] = useState(false);
  const [selectedRoute, setSelectedRoute] = useState<string>('general_queries');
  const [searchedQues, setSearchedQues] = useState<boolean>(false);
  const [open, setOpen] = useState<string | boolean>(false);
  const [icon, setIcon] = useState(-1);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
  const [item, setItem] = useState<TabsProps['items']>([]);
  const { t } = useTranslation();

  useEffect(() => {
    if (lastId !== '')
      getAllFaq()
  }, [lastId]);

  const dataToSend = (data = false) => {
    let tempId = { ...lastId };
    let tempGroupName = groupName;
    if (!data && (tempId !== "" || tempId !== null)) {
      return {
        "marketplace": "amazon_sales_channel",
        "limit": 5,
        "lastId": tempId.nextId,
        "group": tempGroupName
      }
    }
    else {
      return {
        "marketplace": "amazon_sales_channel",
        "limit": 5
      }
    }
  }

  const getAllFaq = (data = false) => {
    let tempArr: any = data ? {} : JSON.parse(JSON.stringify({ ...arr }));
    let showMoreLessInfoTemp: any = { ...showMoreLessInfo };
    setSearchedQues(false);

    props.di.POST('webapi/rest/v1/faq/search', dataToSend(data))
      .then((response: any) => {
        if (response?.success) {
          let tempButtonObj: any = {};
          Object.entries(response?.data?.amazon_sales_channel)?.map(([title, value]: any) => {
            tempButtonObj[title] = false;
            let showMore = value?.['next_page'];
            if (showMore !== null) {
              showMoreLessInfoTemp[title] = {
                'nextId': showMore,
                'flag': true
              };
            }

            let temp: any = value?.data?.map((ele: any) => {
              let obj = { title: ele?.title, content: ele?.answer }
              return obj
            });

            if (Object.keys(showMoreLessInfoTemp).includes(groupName)) {
              if (value?.["next_page"] === null) {
                showMoreLessInfoTemp[groupName]["flag"] = false;
              }
            }

            if (data) {
              Object.keys(showMoreLessInfoTemp).map((key: any) => {
                showMoreLessInfoTemp = {
                  ...showMoreLessInfoTemp,
                  [key]: {
                    ...showMoreLessInfoTemp[key],
                    flag: true
                  }
                }
              })
            }

            if (!tempArr[title]) {
              tempArr[title] = temp;
            }
            else {
              tempArr[title] = [...tempArr[title], ...temp];
            }
          })

          setshowButtonLoading({ ...tempButtonObj })
        }
        setshowMoreLessInfo(JSON.parse(JSON.stringify({ ...showMoreLessInfoTemp })));
        setallFaq(JSON.parse(JSON.stringify(tempArr)));
        setloadSkeleton(false)
        setLoadSectionSkeleton(false)


      })
  }

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 991);
    };
    window.addEventListener('resize', handleResize);
    // Clean up the event listener
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    let tempItem: any = [];
    let tempArr: any = { ...arr };

    Object.keys(tempArr)?.forEach((key: string, index: any) => {
      let obj: any = {};
      obj = {
        key: key.toLowerCase().replace(" ", "_"),
        label: <Text as='p' fontWeight='regular'>{t(key)}</Text>,
        children:
          <React.Fragment>
            <BlockStack gap="500">
              <BlockStack gap="200">
                {
                  Object.keys(tempArr[key]).map((hi: any, idx: any) => {
                    if (tempArr[key][hi] !== null)
                      return (
                        <div
                          onClick={() => {
                            handleToggle(index + "" + idx);
                            toggleCheck(idx);
                          }}
                          style={{ cursor: "pointer" }}
                          key={idx}
                        >
                          <Card roundedAbove="sm">
                            <InlineStack gap="400" align="space-between" wrap={false}>
                              <div className="Custom-Stack-Item--fill">
                                <Text as='p'>
                                  {
                                    searchedQues ?
                                      getHighlightedQues(tempArr[key][hi]?.title, resultQuery)
                                      : t(tempArr[key][hi].title)
                                  }
                                </Text>
                              </div>
                              <div>
                                <Icon
                                  source={icon == idx && open === index + "" + idx ? ChevronUpMinor : ChevronDownMinor} />
                              </div>
                            </InlineStack>
                            <Collapsible
                              open={open === index + "" + idx}
                              id="basic-collapsible"
                              transition={{
                                duration: "500ms",
                                timingFunction: "ease-in-out"
                              }}
                              expandOnPrint
                            >
                              <div>
                                <Text as='span' tone="subdued">
                                  <span className="collapse-on-click" dangerouslySetInnerHTML={{ __html: t(tempArr[key][hi].content) }}></span>
                                </Text>
                              </div>
                            </Collapsible>
                          </Card>
                        </div>
                      );
                  })
                }
              </BlockStack>
              {
                !searchedQues &&
                  tempArr[key].length ? (
                  <InlineStack gap="400" align="center">
                    {
                      showMoreLessInfo?.[key] ? (
                        <>
                          {showMoreLessInfo?.[key]?.["flag"] == true ? (
                            <>
                              <Button
                                onClick={() => {
                                  handleShowMore(key);

                                }}
                                icon={CirclePlusMajor}
                                loading={showButtonLoading[key]}
                              >
                                {t("Show More")}
                              </Button>
                            </>
                          ) : (
                            <Button
                              onClick={() => handleShowLess(key)}
                              icon={CircleMinusMajor}
                              loading={showButtonLoading[key]}
                            >
                              {t("Show Less")}
                            </Button>
                          )}
                        </>
                      ) : null
                    }
                  </InlineStack>
                ) : null
              }
            </BlockStack>
          </React.Fragment>
      }
      tempItem?.push({ ...obj })
    })

    setItem([...tempItem])
  }, [arr, open, showButtonLoading, selectedRoute, searchedQues])

  useEffect(() => {
    if (fromPricingPlan) {
      setSelectedRoute('pricing_plan')
      props.di.globalState.removeLocalStorage('fromPricingPlan')
    }
  }, [arr])

  const updateText = useCallback((value: string) => {
    setInputValue(value);
    setKeyWord(value);
    if (!loading) {
      setLoading(true);
    }
    setInterval(() => {
      if (value == "") {
        setLoading(false)
      }
    }, 1000)
  },
    [loading, options],
  );

  useEffect(() => {
    if (inputValue.trim() !== "") {
      let timer = setTimeout(() => {
        getSuggestions()
      }, 1000)

      return () => clearTimeout(timer)
    } else {
      setLoading(false)
    }
  }, [inputValue])


  const dataToSendForSearchSuggestion = () => {
    let tempQuery = keyword;
    if (keyword !== "") {
      return {
        "marketplace": "amazon_sales_channel",
        "keyword": tempQuery?.trim(),
        "limit": 10
      }
    }
    else {
      return {
        "marketplace": "amazon_sales_channel",
        "limit": 10
      }
    }
  }

  const getSuggestions = () => {
    let tempArr: any = [];
    props.di.POST('webapi/rest/v1/faq/search', dataToSendForSearchSuggestion()).then((response: any) => {
      if (response.success) {
        if (response.data.length < 1) {
          setLoading(false)
          setNoResult(true)
          setOptions([])
        }
        else setNoResult(true)
        Object.entries(response.data?.amazon_sales_channel).map(([title, val]: any) => {
          val.data.map((ele: any) => {
            tempArr.push({ label: ele.title, value: ele.title })
          });
        })
        setOptions(tempArr)
        setLoading(false)
        setLoadSectionSkeleton(false)
      }
    })
  }

  const updateSelection = useCallback((selected: any[]) => {
    if (inputValue.trim() !== "") {
      let itemFound = false
      const selectedText = selected.map((selectedItem: any) => {
        const matchedOption = options.find((option: any) => {
          itemFound = true
          return option.value.match(selectedItem);
        });
        setSelectedOptions(itemFound ? selectedItem : selected)
        setresultQuery(selectedItem)
        setInputValue("")
        getSearchResult(itemFound ? selectedItem : selected)
        setOptions([])
        setLoadSectionSkeleton(true)
      });
    }
  },
    [options],
  );

  const getSearchResult = async (resultQuery: string) => {
    let tempArr: any = { ...arr };
    setOpen(false)
    if (inputValue.trim() !== '') {
      await props.di.POST('webapi/rest/v1/faq/search',
        {
          "marketplace": "amazon_sales_channel",
          "keyword": resultQuery,
          "limit": 10
        }
      ).then((response: any) => {
        if (response?.data?.length < 1) {
          setallFaq([])
          setLoadSectionSkeleton(false)
        }
        if (response.success) {
          Object.entries(response.data?.amazon_sales_channel).map(([title, value]: any) => {
            value.data.map((ele: any) => {
              if (ele?.title?.indexOf(resultQuery) > -1) {
                setSearchedQues(true)
                setSelectedRoute(ele?.['group']?.toLowerCase()?.replace(" ", "_"))
                tempArr[title] = [arr[title].find((key: any) => key?.title === ele?.title)]
              }
            });
          })

        }
        else setSearchedQues(false)
        setallFaq(JSON.parse(JSON.stringify(tempArr)));
        setloadSkeleton(false)
        setLoadSectionSkeleton(false)
      })
    }
  }

  function handleKeyPress(e: any) {
    if (inputValue.trim() !== "") {
      let keyCode = e.keyCode
      if (keyCode === 13) {
        setLoading(true)
        updateSelection([inputValue.trim()])
        setSelectedOptions([inputValue.trim()])
        setLoadSectionSkeleton(true)
        getSearchResult(inputValue.trim())
        setresultQuery(inputValue.trim())
        setInputValue('')
        setOpen(false)
        setTimeout(() => {
          setOptions([]);
          return;
        }, 1000);
      }
    }
  }

  const handleClearButtonClick = useCallback(() => {
    updateText('')
    setOptions([])
  }, []);

  const textField = (
    <div className="custom-spacing" onKeyDown={(e) => handleKeyPress(e)}>
      <Autocomplete.TextField
        label=""
        autoComplete="off"
        onChange={updateText}
        value={inputValue}
        prefix={<Icon source={SearchMinor} tone="base" />}
        placeholder={t("Search your query here...")}
        onClearButtonClick={handleClearButtonClick}
        clearButton={true}
      />
    </div >
  );

  const handleToggle = useCallback((index: string) => {
    setOpen((prevOpen) => (prevOpen === "" + index ? false : index))
  }, []);

  const handleShowMore = (section: string) => {
    let temp: any = { ...showButtonLoading };
    temp[section] = true;
    setshowButtonLoading({ ...temp });
    setLastId(showMoreLessInfo[section] !== null ? showMoreLessInfo[section] : "")
    setGroupName(section)
  };

  const handleShowLess = (type: string) => {
    let temp = { ...arr }
    let showTemp = { ...showMoreLessInfo }
    let buttonLoader = { ...showButtonLoading }
    temp = {
      ...temp,
      [type]: temp?.[type].slice(0, 5)
    }
    buttonLoader = {
      ...buttonLoader,
      [type]: true
    }
    setshowButtonLoading(buttonLoader)
    setTimeout(() => {
      setallFaq(temp)
      buttonLoader = {
        ...buttonLoader,
        [type]: false
      }
      setshowButtonLoading(buttonLoader)

    }, 800)


    setLastId('')
    setGroupName('')
    getAllFaq(true)
    showTemp = {
      ...showTemp,
      [type]: {
        ...showTemp?.[type],
        "flag": true
      }
    }

    setshowMoreLessInfo(JSON.parse(JSON.stringify({ ...showTemp })))
  }

  const emptyState = (
    <React.Fragment>
      <InlineStack gap="400" align="center">
        <div>
          <Icon source={SearchMinor} />
        </div>
        <div style={{ textAlign: 'center' }}>
          <Text as='span'>{t("Could not find any results")}</Text>
        </div>
      </InlineStack>
    </React.Fragment>
  );

  const toggleCheck = (idx: any) => {
    if (idx === setIcon) {
      setIcon(-1)
    } else {
      setIcon(idx)
    }
  }

  const removeTag = () => {
    setSelectedOptions([]);
    setLastId('')
    setOpen(false)
    setLoadSectionSkeleton(true)
    setallFaq({})
    getAllFaq(true)
  }

  return (
    <React.Fragment>
      <Card roundedAbove="sm">
        <BlockStack gap="800">
          <BlockStack gap="400">
            <Autocomplete
              options={inputValue !== '' && options}
              selected={selectedOptions}
              onSelect={updateSelection}
              loading={loading}
              textField={textField}
              emptyState={noResult ? inputValue !== "" ? emptyState : "" : ""}
            />
            {
              selectedOptions.length > 0 &&
              <div className="custom-spacing">
                <InlineStack blockAlign="center" gap="200">
                  <Text as='p' fontWeight="semibold">Search results for:</Text>
                  <Tag
                    onRemove={() => removeTag()}
                  >
                    {selectedOptions}
                  </Tag>
                </InlineStack>
              </div>
            }
          </BlockStack>
          {
            !loadSectionSkeleton ?
              Object.keys(arr).length > 0 ?
                <div className='Custom__Tab--Faq'>
                  <Tabs
                    tabPosition={isSmallScreen ? "top" : "left"}
                    defaultActiveKey={selectedRoute}
                    items={item}
                    onChange={(id: any) => {
                      setSelectedRoute(id);
                      setSearchedQues(false);
                      selectedOptions?.length > 0 && removeTag();
                    }} />
                </div>
                : renderNoResult()
              : renderSkeletonForSection()
          }
        </BlockStack>
      </Card>
    </React.Fragment>
  );


  function renderSkeletonForSection() {
    return <>
      <div className='Custom__Skeleton--Faq'>
        <Grid columns={{ xs: 1, sm: 1, md: 1, lg: 4, xl: 4 }}>
          <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }}>
            <div className='Custom__Mobile--Skeleton'>
              <Box padding="400" borderRadius="100" shadow="300">
                <BlockStack gap="400">
                  <SkeletonBodyText lines={1} />
                  <Bleed marginInline='400'>
                    <Divider />
                  </Bleed>
                  <SkeletonBodyText lines={1} />
                  <Bleed marginInline='400'>
                    <Divider />
                  </Bleed>
                  <SkeletonBodyText lines={1} />
                  <Bleed marginInline='400'>
                    <Divider />
                  </Bleed>
                  <SkeletonBodyText lines={1} />
                  <Bleed marginInline='400'>
                    <Divider />
                  </Bleed>
                  <SkeletonBodyText lines={1} />
                  <Bleed marginInline='400'>
                    <Divider />
                  </Bleed>
                  <SkeletonBodyText lines={1} />
                </BlockStack>
              </Box>
            </div>
          </Grid.Cell>
          <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 1, lg: 3, xl: 3 }}>
            <BlockStack gap="400">
              <Card roundedAbove="sm">
                <SkeletonBodyText lines={1} />
              </Card>
              <Card roundedAbove="sm">
                <SkeletonBodyText lines={1} />
              </Card>
              <Card roundedAbove="sm">
                <SkeletonBodyText lines={1} />
              </Card>
              <Card roundedAbove="sm">
                <SkeletonBodyText lines={1} />
              </Card>
              <Card roundedAbove="sm">
                <SkeletonBodyText lines={1} />
              </Card>
            </BlockStack>
          </Grid.Cell>
        </Grid>
      </div>
    </>;
  }

  function SkeletonExample() {
    return <>
      <div className='Custom__Skeleton--Faq'>
        <Grid columns={{ xs: 1, sm: 1, md: 4, lg: 4, xl: 4 }}>
          <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }}>
            <Box padding="400" borderRadius="100" shadow="300">
              <BlockStack gap="400">
                <SkeletonBodyText lines={1} />
                <Bleed marginInline='400'>
                  <Divider />
                </Bleed>
                <SkeletonBodyText lines={1} />
                <Bleed marginInline='400'>
                  <Divider />
                </Bleed>
                <SkeletonBodyText lines={1} />
                <Bleed marginInline='400'>
                  <Divider />
                </Bleed>
                <SkeletonBodyText lines={1} />
                <Bleed marginInline='400'>
                  <Divider />
                </Bleed>
                <SkeletonBodyText lines={1} />
                <Bleed marginInline='400'>
                  <Divider />
                </Bleed>
                <SkeletonBodyText lines={1} />
              </BlockStack>
            </Box>
          </Grid.Cell>
          <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 3, lg: 3, xl: 3 }}>
            <BlockStack gap="400">
              <Card roundedAbove="sm">
                <SkeletonBodyText lines={1} />
              </Card>
              <Card roundedAbove="sm">
                <SkeletonBodyText lines={1} />
              </Card>
              <Card roundedAbove="sm">
                <SkeletonBodyText lines={1} />
              </Card>
              <Card roundedAbove="sm">
                <SkeletonBodyText lines={1} />
              </Card>
              <Card roundedAbove="sm">
                <SkeletonBodyText lines={1} />
              </Card>
            </BlockStack>
          </Grid.Cell>
        </Grid>
      </div>
    </>;
  }

  function renderNoResult() {
    return (
      <div>
        {loadSkeleton ? SkeletonExample() :
          <BlockStack gap="800" inlineAlign="center">
            <img src={logo} />
            <Text as='p'>Nothing matches to your query.
            </Text>
          </BlockStack>
        }
      </div >
    );
  }

  function getHighlightedQues(question: any = "", searchedQues: any = "") {
    if (question == searchedQues) {
      question = reactStringReplace(question, searchedQues, (match: any) => {
        return <Text as='span'>{t(match)}</Text>
      })
      return (question);
    }
    else {
      let searched = "";
      if (searchedQues.includes(".")) {
        searched = searchedQues.replaceAll(".", " .");
      }
      else if (searchedQues.includes("?")) {
        searched = searchedQues.replaceAll("?", " ?");
      }
      else searched = searchedQues;

      let splittedWords = searched.split(" ");

      for (let i = 0; i < splittedWords.length; i++) {
        question = reactStringReplace(question, splittedWords[i], (match: any) => {
          return <Text as='span'>{t(match)}</Text>
        })
      }
      return question;
    }
  }
}

export default DI(NewFaq, {
  func: { syncConnectorInfo, syncNecessaryInfo },
});